import React, { Component } from 'react';
import { Button, Form } from 'react-bootstrap'
import DrawerMenu from '../DrawerMenu'
import { Route } from 'react-router'
import ApiManager from '../../ApiManager'
import { withRouter, BrowserRouter, Switch, Redirect } from 'react-router-dom'
import { EditorState, convertToRaw, convertFromHTML, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs'
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
class MainScreen extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isAdding: false,
      phone: "",
      note: "",
      editorState: EditorState.createEmpty(),
      about: "",
      emailsKp: "",
      emailsSchedules: "",
      emailsHelp: "",
      orderPurposes: "",
      uploadedImages: []
    }
  }
  componentDidMount() {
    ApiManager.fetchSettings().then(response => {
      // const blocksFromHTML = convertFromHTML(response.data.about);
      const blocksFromHTML = htmlToDraft(response.data.about);
      const state = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      var emailsKp = response.data.emails_kp.reduce((prevValue, currentValue) => prevValue + currentValue + ", ", "").slice(0, -2)
      var emailsSchedules = response.data.emails_schedules.reduce((prevValue, currentValue) => prevValue + currentValue + ", ", "").slice(0, -2)
      var emailsHelp = response.data.emails_help.reduce((prevValue, currentValue) => prevValue + currentValue + ", ", "").slice(0, -2)
      var orderPurposes = response.data.order_purposes.reduce((prevValue, currentValue) => prevValue + currentValue + ", ", "").slice(0, -2)

      this.setState({
        phone: response.data.phone,
        note: response.data.note,
        editorState: EditorState.createWithContent(state),
        emailsKp: emailsKp,
        emailsSchedules: emailsSchedules,
        emailsHelp: emailsHelp,
        orderPurposes: orderPurposes,
        about: response.data.about
      })
    })
  }
  updateSettings() {
    var emailsKp = this.state.emailsKp.replace(" ", "").split(",")
    var emailsSchedules = this.state.emailsSchedules.replace(" ", "").split(",")
    var emailsHelp = this.state.emailsHelp.replace(" ", "").split(",")
    var orderPurposes = this.state.orderPurposes.replace(" ", "").split(",")
    if (this.state.phone != '' && this.state.note != '' && this.state.about != '' && !this.state.isAdding && emailsKp.length != 0
      && emailsSchedules.length != 0 && emailsHelp.length != 0) {
      this.setState({ isAdding: true })
      ApiManager.updateSettings(this.state.phone, this.state.note, this.state.about, JSON.stringify(emailsKp), JSON.stringify(emailsSchedules), JSON.stringify(emailsHelp), JSON.stringify(orderPurposes)).then(response => {
        if (response.success) {
          this.setState({
            isAdding: false
          })
        }
      })
    }
  }
  onEditorStateChange: Function = (editorState) => {
    this.setState({
      editorState,
      about: draftToHtml(convertToRaw(editorState.getCurrentContent()))
    });
  };

  // base64 uploader
  imageUploadCallBack = file => new Promise(
    (resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      let img = new Image();
      // let url = ''
      reader.onload = function (e) {
        img.src = this.result
      }
      img.onload = function () {
        // console.log(img.src.length)
        // Zoom the canvas needed for the image (you can also define the canvas tag directly in the DOM, so that the compressed image can be directly displayed without going to base64)
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');

        // image original size
        var originWidth = this.width;
        var originHeight = this.height;

        // Maximum size limit, you can achieve image compression by setting the width and height
        var maxWidth = 400,
          maxHeight = 500;
        // target size
        var targetWidth = originWidth,
          targetHeight = originHeight;
        // Image size exceeds 300x300 limit
        if (originWidth > maxWidth || originHeight > maxHeight) {
          if (originWidth / originHeight > maxWidth / maxHeight) {
            // wider, size limited by width
            targetWidth = maxWidth;
            targetHeight = Math.round(maxWidth * (originHeight / originWidth));
          } else {
            targetHeight = maxHeight;
            targetWidth = Math.round(maxHeight * (originWidth / originHeight));
          }
        }
        // canvas scales the image
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        // clear the canvas
        context.clearRect(0, 0, targetWidth, targetHeight);
        // Image Compression 
        context.drawImage(img, 0, 0, targetWidth, targetHeight);
        /* The first parameter is the created img object; the second three parameters are the upper left corner coordinates, and the second two are the canvas area width and height */

        // compressed image to base64 url
        /*canvas.toDataURL(mimeType, qualityArgument), mimeType The default value is 'image/png';
            * qualityArgument indicates the quality of the exported image. This parameter is valid only when exported to jpeg and webp formats. The default value is 0.92*/
        var newUrl = canvas.toDataURL('image/jpeg', 0.92);//base64 format
        // console.log(newUrl.length)

        resolve({
          data: {
            link: newUrl
          }
        })
        // You can also convert the compressed image to blob format for uploading
        // canvas.toBlob((blob) => {
        //   console.log(blob)
        //   // Pass the blob as a parameter to the backend
        // }, 'image/jpeg', 0.92)
      }
    }
  );

  render() {
    const { editorState } = this.state;

    var AddBtnTitle = this.state.isAdding ? <span><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Пожалуйста, подождите</span> : <span>Обновить</span>
    return (
      <div style={{ margin: "0 auto", width: '50%' }}>
        <Form>
          <Form.Group controlId="exampleForm.ControlInput1">
            <Form.Label>Общий номер телефона</Form.Label>
            <Form.Control type="phone" placeholder="+7 (XXX) XXX-XX-XX" value={this.state.phone} required onChange={event => this.setState({ "phone": event.target.value })} />
          </Form.Group>
          <Form.Group controlId="exampleForm.ControlTextarea1">
            <Form.Label>О компании</Form.Label>
            <div style={{ border: '1px solid #ccc', padding: '8px' }}>
              <Editor
                editorState={editorState}
                wrapperClassName="demo-wrapper"
                editorClassName="demo-editor"
                toolbar={{
                  options: ['inline', 'list', 'textAlign', 'colorPicker', 'link', 'image', 'remove', 'history'],
                  inline: {
                    options: ['bold', 'italic'],
                  },
                  image: {
                    uploadCallback: this.imageUploadCallBack.bind(this),
                    urlEnabled: false,
                    uploadEnabled: true,
                    previewImage: true,
                    alt: { present: true, mandatory: false },
                    inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
                  }

                }}
                onEditorStateChange={this.onEditorStateChange}
              />
            </div>
          </Form.Group>
          <Form.Group controlId="exampleForm.ControlInput1">
            <Form.Label>Дополнительные email-адреса для запросов КП</Form.Label>
            <Form.Control type="phone" placeholder="Email-адреса через запятую" value={this.state.emailsKp} required onChange={event => this.setState({ emailsKp: event.target.value })} />
          </Form.Group>
          <Form.Group controlId="exampleForm.ControlInput1">
            <Form.Label>Дополнительные email-адреса для заявок графиков кранов</Form.Label>
            <Form.Control type="phone" placeholder="Email-адреса через запятую" value={this.state.emailsSchedules} required onChange={event => this.setState({ emailsSchedules: event.target.value })} />
          </Form.Group>
          <Form.Group controlId="exampleForm.ControlInput1">
            <Form.Label>Дополнительные email-адреса для заявок HELP</Form.Label>
            <Form.Control type="phone" placeholder="Email-адреса через запятую" value={this.state.emailsHelp} required onChange={event => this.setState({ emailsHelp: event.target.value })} />
          </Form.Group>
          <Form.Group controlId="exampleForm.ControlTextarea1">
            <Form.Label>Примечание к форме отправки заявки</Form.Label>
            <Form.Control as="textarea" rows="5" value={this.state.note} onChange={event => this.setState({ "note": event.target.value })} required />
          </Form.Group>
          <Form.Group controlId="exampleForm.ControlTextarea1">
            <Form.Label>Цели вызова</Form.Label>
            <Form.Control type="phone" placeholder="Цели вызова через запятую" value={this.state.orderPurposes} required onChange={event => this.setState({ orderPurposes: event.target.value })} />
          </Form.Group>
          <Button style={{ width: '300px', paddingTop: '8px', paddingBottom: '8px' }} variant="primary" onClick={() => this.updateSettings()}>
            {AddBtnTitle}
          </Button>
        </Form>
      </div>
    );
  }
}
export default MainScreen;